var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTask = function SvgTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "task_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#task_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m10.935 15.279-1.593-1.592a.8.8 0 0 0-.243-.168.7.7 0 0 0-.271-.056.79.79 0 0 0-.54.224.74.74 0 0 0-.232.534q0 .302.233.535l2.028 2.044a.83.83 0 0 0 .633.256.831.831 0 0 0 .633-.256l4.128-4.129a.75.75 0 0 0 .229-.537.73.73 0 0 0-.229-.548.74.74 0 0 0-.542-.232.74.74 0 0 0-.542.232zM6.308 21.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V4.308q0-.758.525-1.283T6.308 2.5h7.194q.362 0 .695.14.334.141.58.387l4.196 4.196q.246.246.387.58.14.333.14.695v11.194q0 .758-.525 1.283t-1.283.525zM13.5 7.596V4H6.308a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.212v15.384q0 .116.096.212a.3.3 0 0 0 .212.096h11.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8.5h-3.596a.88.88 0 0 1-.645-.259.88.88 0 0 1-.259-.645"
  }))));
};
export default SvgTask;